var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85024 0.525122C9.15008 -0.17504 8.01489 -0.175041 7.31473 0.525121L1.0683 6.77154C0.838528 7.00131 0.675521 7.28921 0.59671 7.60446L0.0551623 9.77065C-0.273104 11.0837 0.916281 12.2731 2.22935 11.9448L4.39554 11.4033C4.71078 11.3245 4.99868 11.1615 5.22845 10.9317L11.4749 4.68528C12.175 3.98512 12.175 2.84993 11.4749 2.14976L9.85024 0.525122ZM8.40137 1.61177C8.5014 1.51175 8.66357 1.51175 8.76359 1.61177L10.3882 3.23641C10.4883 3.33643 10.4883 3.4986 10.3882 3.59863L4.99672 8.99013L3.00986 7.00327L8.40137 1.61177ZM2.03216 8.19886L1.54603 10.1434C1.49914 10.331 1.66905 10.5009 1.85663 10.454L3.80113 9.96784L2.03216 8.19886Z",
    fill: "#454A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7573c4fbb520f870e764857077762ba5.svg";
export { ForwardRef as ReactComponent };